import { Form, Formik } from 'formik';
import React from 'react';

import { useAffiliateSettingsUpdate } from '../../../../hooks';
import { AffiliateSettings } from '../../../../utils/backend-api/settings';
import { Button } from '../../../BaseUI';
import { DropdownField, TextField } from '../../../FormFields';
import schema from './schema';
import styles from './styles.module.css';

const PAYMENT_METHOD_OPTIONS = [
  { label: 'Venmo', value: 'venmo' },
  { label: 'PayPal', value: 'paypal' },
];

const ReferralPaymentForm = ({ initialValues }) => {
  const { mutate: updateAffiliateSettings } = useAffiliateSettingsUpdate();

  const handleSubmit = ({ paymentId, paymentType }: AffiliateSettings) => {
    const sanitizedParams = {
      payment_id: paymentId,
      payment_type: paymentType.value,
    };
    updateAffiliateSettings(sanitizedParams);
  };

  return (
    <Formik
      enableReinitialize
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validationSchema={schema}
    >
      {(formik) => (
        <Form>
          <DropdownField
            name="paymentType"
            options={PAYMENT_METHOD_OPTIONS}
            placeholder="Payment Method"
          />
          <TextField name="paymentId" placeholder="Handle" />
          <div className={styles.buttonContainer}>
            <Button
              type="submit"
              variant="primary"
              width="short"
              disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
            >
              {formik.isSubmitting ? 'Submitting' : 'Submit'}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ReferralPaymentForm;
